import { useContext, useMemo } from "react";
import { CsvContext } from "../provider/CSVProvider";
import OptionsDisplayChart from "../components/OptionsDisplayChart";
import { numFormatter } from '../utils/formatterUtils';
import Decimal from 'decimal.js';
import { useAuth } from "react-oidc-context";
import Admin from "../components/Admin";

const OptionsDisplay = () => {
    
    const auth = useAuth();
    const { optionsData } = useContext(CsvContext);

    const optionsFormatted = useMemo(() => {
    
      const headerNames = {
        'Provider': 'Provider',
        'SegmentType': 'Segment Type',
        'SegmentMapping': 'Segment Mapping',
        'Index': 'Index',
        'Years': 'Years',
        'Minimum': 'Minimum Investment',
        'Buffer': 'Buffer',
        'Floor': 'Floor',
        'DownsideParticipation': 'Downside Participation',
        'Dual': 'Dual',
        'Cap': 'Cap',
        'Step': 'Step',
        'Yield': 'Yield',
        'YieldInterest': 'Yield Interest',
        'Participation': 'Participation',
        'Participation2': 'Participation 2',
        'Tier': 'Tier',
        'Milestone': 'Milestone',
        'Boost': 'Boost',
        'Spread': 'Spread',
        'Protection': 'Protection',
        'AnnualFeeRate': 'Annual Fee Rate'
      };
  
      const dollarFormatFields = [
        'Minimum'
      ];
  
      const percentFormatFields = [
        'Buffer',
        'Floor',
        'DownsideParticipation',
        'Dual',
        'Cap',
        'Step',
        'Yield',
        'YieldInterest',
        'Participation',
        'Participation2',
        'Tier',
        'Milestone',
        'Boost',
        'Spread',
        'Protection',
        'AnnualFeeRate'
      ];
  
      const cellFormatter = (key, value) => {
        if (dollarFormatFields.includes(key)) {
          return numFormatter(new Decimal(value.replace(',','')),'$');
        } else if (percentFormatFields.includes(key)) {
          return value !== 'Uncapped' && value !== '-' ? `${value}%` : value;
        } else {
          return value;
        }
      };
  
      return optionsData.map(option => {
        const formattedOption = {};
        Object.entries(option).forEach(([key, value]) => {
          const newKey = headerNames[key];
          formattedOption[newKey] = cellFormatter(key, value || '-');
        });
        return formattedOption;
      });
    }, [optionsData]);

    return (
      <div className="row">
        <div className="col s12">
          {optionsFormatted.length !== 0 && <OptionsDisplayChart options={optionsFormatted}/>}
          <div className="divider" style={{ marginTop: '1rem' }}></div>
          {auth.isAuthenticated && <Admin />}
          {!auth.isAuthenticated && 
            <blockquote style={{ borderLeft: '5px solid blue' }}>
              <b>Please <span className="blue-text text-darken-4" style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={auth.signinRedirect}>sign in</span> to modify rates</b>
            </blockquote>}
        </div>
      </div>
    );
}

export default OptionsDisplay;